// * RTK Query
// material ui
import { Card, CardContent, CardHeader } from '@mui/material';

// relative
// * Components
import InsufficientData from './InssuficientData';
import SystemQoS from './SystemQoS';

import { DateTime } from 'luxon';

// * Utils
function formatDanishDate(timestamp) {
  if (!timestamp) return '';
  return DateTime.fromISO(timestamp, { zone: 'utc' })
    .setLocale('da')
    .toFormat('dd. MMM yyyy HH:mm:ss');
}

function renderAlarmSubtype(alarmSubType, metaData) {
  switch (alarmSubType) {
    case 'SystemQoS':
      return <SystemQoS data={metaData} />;
    case 'InsufficientData':
      return <InsufficientData data={metaData} />;
    default:
      return <pre>{JSON.stringify(metaData, null, 2)}</pre>;
  }
}

const EnergyXplorerOperations = ({ alarm }) => {
  console.log('Rendering EnergyXplorerOperations with alarm:', alarm);

  const metaData = JSON.parse(alarm?.MetaData || '{}');
  const subType = alarm?.AlarmSubtype || 'Unknown Subtype';

  console.log('Parsed MetaData:', metaData);

  return (
    <Card>
      <CardHeader
        title={`EnergyXplorer Operations - ${subType}`}
        subheader={`${formatDanishDate(alarm?.DataFrom)} - ${formatDanishDate(alarm?.DataTo)}`}
        slotProps={{
          title: { variant: 'subtitle1' },
          subheader: { variant: 'caption' }
        }} />
      <CardContent style={{ marginTop: -32 }}>
        {renderAlarmSubtype(subType, metaData)}
      </CardContent>
    </Card>
  );
};

export default EnergyXplorerOperations;

